import { LearnerCertificateDownloadDto } from 'collaboration-service';
import * as React from 'react';
import EditPartContainer, { EditPartContainerType } from '../EditPartContainer';
import EditPartLabelAndEditor from '../EditPartLabelAndEditor';
import EditCategoryLikeMultiple from '../Editors/EditCategoryLikeMultiple';
import EditNumber from '../Editors/EditNumber';

interface PostEditCertificateProps {
    epc: EditPartContainerType;
    post: LearnerCertificateDownloadDto;
    registerClosed?: boolean;
}

const PostEditCertificate = (p: PostEditCertificateProps) => {
    const { epc, registerClosed } = p;

    return (
        <>
            <EditPartContainer icon="cog" title="general properties" {...epc} registerClosed={registerClosed}>
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "tag", content: "categories" }, editor: <EditCategoryLikeMultiple<LearnerCertificateDownloadDto> getter={x => x.categories} toSelect="categories" /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>

            <EditPartContainer icon="cog" title="certificate properties" {...epc} registerClosed={registerClosed}>
                <EditPartLabelAndEditor>
                    {[
                        { label: { icon: "calendar", content: "expires after days" }, editor: <EditNumber<LearnerCertificateDownloadDto> getter={x => x.expiresAfterDays} min={7} max={2000} step={7} /> },
                        { label: { icon: "stats", content: "level increases by" }, editor: <EditNumber<LearnerCertificateDownloadDto> getter={x => x.levelIncreasesBy} min={0} max={10} step={1} /> },
                    ]}
                </EditPartLabelAndEditor>
            </EditPartContainer>
        </>
    );
}
export default PostEditCertificate;